<template>
  <v-layout row wrap fill-height class="tile-layout">
    <v-flex xs12 md6 pa-1>
      <v-text-field box label="Header" disabled hide-details v-model="columnData.Header">
      </v-text-field>            
    </v-flex>
    <v-flex xs12 md3 pa-1>
      <v-text-field box label="Type" disabled hide-details v-model="columnData.ValueType">
      </v-text-field>            
    </v-flex>
    <v-flex xs12 md3 pa-1>
      <v-text-field box label="Strictness" disabled hide-details v-model="columnData.Strictness">
      </v-text-field>            
    </v-flex>
  </v-layout>
</template>

<script>

  export default {
    components: {
    },
    props: {
      columnName: null,
      columnData: null,
    },
    data() {
      return {        
      }
    },
    computed: {
    },
    methods: {
    },
    async mounted() {
    },
  }
</script>

<style lang="stylus" scoped></style>